import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import Button from "../../../../components/common/button/Button";
import styles from "./Settings.scss";
import { Form, FormGroup } from "react-bootstrap";
import Input from "../../../../components/common/input/Input";
import { Row, Col } from "react-bootstrap";
import {
  required,
  requiredFirstName,
  requiredLastName,
  minLength,
  email,
  alphaSymbolicSpace
} from "../../../../utils/forms/validators";

export const emailValidation = msg => email(msg);
export const minLengthValidation = (min, msg) => minLength(min, msg);

export const emailVal = emailValidation("Please enter a valid email address.");
export const password = minLengthValidation(
  8,
  "Password must be at least 8 characters."
);
const firstName = alphaSymbolicSpace("Please enter a valid first name.");
const lastName = alphaSymbolicSpace("Please enter a valid last name.");

class Settings extends Component {
  render() {
    const { submitting, valid } = this.props;

    return (
      <section className={styles.settings}>
        <div className={styles.content}>
          <h2 className={styles.title}>Account Settings</h2>

          <Form onSubmit={this.props.handleSubmit}>
            <div className={styles.form}>
              <FormGroup>
                <div className={styles.sectionTitle}>Login</div>

                <Row>
                  <Col md={12} xs={12}>
                    <Field
                      name="email"
                      type="text"
                      placeholder="Email Address"
                      component={Input}
                      validate={[required, emailVal]}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={12} xs={12}>
                    <Field
                      name="password"
                      type="password"
                      placeholder="Change Password"
                      component={Input}
                      validate={password}
                      showPasswordIcon
                      autoComplete="off"
                    />
                  </Col>
                </Row>
              </FormGroup>
              <div className={styles.divider} />
              <FormGroup>
                <div className={styles.sectionTitle}>Name</div>

                <Row>
                  <Col md={12} xs={12}>
                    <Field
                      name="first_name"
                      type="text"
                      placeholder="First Name"
                      component={Input}
                      validate={[requiredFirstName, firstName]}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={12} xs={12}>
                    <Field
                      name="last_name"
                      type="text"
                      placeholder="Last Name"
                      component={Input}
                      validate={[requiredLastName, lastName]}
                    />
                  </Col>
                </Row>
              </FormGroup>

              <div className={styles.dividerDouble} />

              <div className={styles.CTAContainer}>
                <Button
                  isPrimary
                  type="submit"
                  size={"large"}
                  noMarginBottom
                  label="Save Changes"
                  isDisabled={!valid || submitting}
                />
              </div>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

Settings = reduxForm({
  form: "candidateSettings",
  fields: ["email", "password", "first_name", "last_name"],
  enableReinitialize: true
})(Settings);

Settings = connect((state, ownProps) => {
  return {
    initialValues: ownProps.userData
  };
})(Settings);

export default Settings;



// WEBPACK FOOTER //
// ./src/routes/candidate/settings/components/Settings.js